import { getCapacityDashboard } from '@dispatch/shared/services';
import {
  CapacityDashboard_Request,
  CapacityResponseSchema,
} from '@dispatch/shared/types';
import { useNotification } from '@dispatch/web/hooks';
import { useMutation, UseMutationResult } from 'react-query';
import { z } from 'zod';

type CapacityDashboardApiResponseSchema = z.infer<
  typeof CapacityResponseSchema
>;

export const useCapacityDashboardMutation = (): UseMutationResult<
  CapacityDashboardApiResponseSchema,
  Error,
  CapacityDashboard_Request
> => {
  const { notifyError } = useNotification();
  return useMutation<
    CapacityDashboardApiResponseSchema,
    Error,
    CapacityDashboard_Request
  >((request: CapacityDashboard_Request) => getCapacityDashboard(request), {
    onError: () => {
      notifyError('Error', 'Error fetching capacity dashboard data');
    },
  });
};
